import React from 'react';
import EventDocListActions from 'flux/actions/EventDocListActions';

export default React.createClass({
  displayName: 'DocPage',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  componentWillMount() {
    document.body.style.backgroundColor = '#1e2131';
  },

  render() {
    const style = {
      color: 'white',
      margin: 'auto',
      display: 'flex',
      'align-items': 'center',
      'font-size': '32px',
      height: '50vh',
    };
    return <div style={style}>Your doc is downloading...</div>;
  },

  componentDidMount() {
    let routeParams = this.context.router.state.params;

    let { teamId, eventId, docId } = routeParams;

    EventDocListActions.downloadDoc(teamId, eventId, docId, window);
  },
});
